import { SecondaryTradeResource } from 'app/_services/secondaryTradeService';
import { DATES } from 'app/_constants/dates.constant';
import * as angular from 'angular';

class SecondaryTradeDetailsComponentCtrl implements ng.IController {
    id: number;
    isLoggedIn: boolean;
    authenticatedUser: LoginResult;
    uiLoading: boolean;
    uiLoadingError: boolean;
    headlineTitle: string;
    state: string;
    response: ResponseDto;
    proposal: ProposalDto;
    pdfExportUrl: any;
    ownProposal: boolean;
    ownResponse: boolean;
    tsoShipperNote0: string[];
    tsoShipperNote1: string[];

    constructor(
        private reportingService: any,
        private auctionResource: any,
        private TradeProposals: any,
        private SecondaryTrade: SecondaryTradeResource,
        private DATES: DATES
    ) {}

    $onInit(): void {
        this.isLoggedIn = !!this.authenticatedUser;
        this.uiLoading = true;
        this.uiLoadingError = false;

        this.SecondaryTrade.get(
            { id: this.id },
            (res) => {
                this.proposal = res.proposal;
                this.tsoShipperNote0 = [res.tsoShipperNote0];
                this.tsoShipperNote1 = [res.tsoShipperNote1];
                this.state = res.response.state;
                this.response = res.response;
                this.pdfExportUrl =
                    this.reportingService.mapExportUrls(
                        this.reportingService.REPORT.SECONDARY.TRADE,
                        'PDF'
                    ) +
                    '?id=' +
                    this.id;
                this.ownProposal = res.ownProposal;
                this.ownResponse = res.ownResponse;
            },
            this.onError.bind(this)
        ).$promise.finally(this.onFinally.bind(this));
    }

    onError() {
        this.uiLoadingError = true;
    }

    onFinally() {
        this.uiLoading = false;
    }
}

angular.module('app').component('pkpSecondaryTradeDetails', {
    controller: SecondaryTradeDetailsComponentCtrl,
    template: require('app/secondary-trading/secondary-trade-details.component.html'),
    bindings: {
        id: '<',
        authenticatedUser: '<'
    }
});
